















import { Component, Vue, Model, Prop, Ref } from 'vue-property-decorator'

@Component
export default class Checkbox extends Vue {
  @Model('change') checked!: boolean
  @Prop() strictlyBinded!: boolean
  @Ref() readonly checkbox!: HTMLInputElement

  onChange(event: any) {
    if (this.strictlyBinded) {
      this.checkbox.checked = this.checked // Ensuring checkbox stays equal to "checked" prop
      this.$emit('change', this.checked)
    } else {
      this.$emit('change', event.target.checked)
    }
  }
}
